import {
  BASE_ARTICLE_45,
  BASE_MANAGEMENT_AGREEMENT,
} from 'src/app/_services/constants/base-contracts-info';
import { ContractToSignInfo } from 'src/app/_services/types/contract-template.types';
import { ContractType } from 'src/app/enums/contract-type.enum';
import { InsuranceTypeEnum } from 'src/app/enums/insurance-type.enum';
import { SelectElement } from 'src/app/ui-kit/components/select/select.component';

import { BUSINESS_INSURANCE_BASE } from '../company-insurance-constants';

export const BUSINESS_ACCIDENT_INSURANCE_BASE = 'laa';

export const BUSINESS_ACCIDENT_FORM_BASE = `${BUSINESS_INSURANCE_BASE}/${BUSINESS_ACCIDENT_INSURANCE_BASE}`;

export const CONTRACTS_TO_SIGN: ContractToSignInfo[] = [
  {
    ...BASE_ARTICLE_45,
    name: 'Article 45 laa',
    type: ContractType.ARTICLE_45,
    insuranceType: InsuranceTypeEnum.BUSINESS_ACCIDENT,
  },
  {
    ...BASE_MANAGEMENT_AGREEMENT,
    name: 'Mandat gestion laa',
    type: ContractType.MANAGEMENT_AGREEMENT,
    insuranceType: InsuranceTypeEnum.BUSINESS_ACCIDENT,
  },
];

// Select options for waiting days
export const WAITING_DAYS_OPTIONS: SelectElement<number>[] = [
  { value: 0, label: '0 jour' },
  { value: 3, label: '3 jours' },
  { value: 7, label: '7 jours' },
  { value: 14, label: '14 jours' },
  { value: 30, label: '30 jours' },
];
